import Button from '@src/components/atoms/buttons/button';
import TriangleErrorIcon from '@src/components/icons/triangleErrorIcon';
import { errorContent } from '@src/constants';

interface ErrorContentProps {
  description?: string;
  onRetry?: () => void;
  isRetrying?: boolean;
}

export default function ErrorContent({
  description = errorContent.description,
  onRetry,
  isRetrying = false,
}: ErrorContentProps) {
  return (
    <div className="flex h-[400px] flex-col items-center justify-center gap-6">
      <div className="h-[52px] w-[52px] rounded-full bg-semantic-error-100 p-[14px] shadow-Error-Shadow-1">
        <TriangleErrorIcon className="h-6 w-6 text-semantic-error-500" />
      </div>
      <div className="flex flex-col gap-3 text-center">
        <p className="body18 font-semibold text-semantic-error-500">
          {errorContent.title}
        </p>
        <p className="body14 max-w-[278px] font-medium dark:text-gray-100">
          {isRetrying ? errorContent.retrying : description}
        </p>
      </div>
      {onRetry && (
        <Button
          onClick={onRetry}
          variant="neutral"
          disabled={isRetrying}
          isLoading={isRetrying}
        >
          {isRetrying ? 'Retrying' : 'Try again'}
        </Button>
      )}
    </div>
  );
}
